import { Col, Row } from "react-bootstrap";
import type { PkSummary } from "../../../types/playerPk";
import PkStatTile, { formatRatio } from "./PkStatTile";

type Props = {
  summary: PkSummary;
};

// Headline numbers for the selected range.
const PkSummaryTiles = ({ summary }: Props) => (
  <Row className="g-3">
    <Col xs={6} md={4} xl={2}>
      <PkStatTile label="Kills" value={summary.kills.toLocaleString()} />
    </Col>
    <Col xs={6} md={4} xl={2}>
      <PkStatTile label="Deaths" value={summary.deaths.toLocaleString()} />
    </Col>
    <Col xs={6} md={4} xl={2}>
      <PkStatTile label="Assists" value={summary.assists.toLocaleString()} />
    </Col>
    <Col xs={6} md={4} xl={2}>
      <PkStatTile
        label="K/D"
        value={formatRatio(summary.kdRatio)}
        sub="kills per death"
      />
    </Col>
    <Col xs={6} md={4} xl={2}>
      <PkStatTile
        label="Kill participation"
        value={formatRatio(summary.killParticipation)}
        sub="(kills + assists) per death"
      />
    </Col>
    <Col xs={6} md={4} xl={2}>
      <PkStatTile
        label="Solo kills"
        value={summary.soloPct === null ? "-" : `${summary.soloPct}%`}
        sub={`${summary.soloKills.toLocaleString()} of ${summary.kills.toLocaleString()}`}
      />
    </Col>
  </Row>
);

export default PkSummaryTiles;
